import { render, staticRenderFns } from "./fundMoneyHistory.vue?vue&type=template&id=63895031&scoped=true"
import script from "./fundMoneyHistory.vue?vue&type=script&lang=js"
export * from "./fundMoneyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63895031",
  null
  
)

export default component.exports